export default {
  filtroModelo: {},
  modeloRelatorio: [],
  selectedModelo: [],
  colunasDinamicasModelo: [],
};
